import {
  Box,
  Button,
  Center,
  Flex,
  IconButton,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { VendeAIAPI } from "./utils";
import { CustomModal } from "components/custom-modal";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  CloseIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";
import { FaSave } from "react-icons/fa";
import { useApplicationContext } from "contexts/ApplicationContext";
import { sortArrayBy } from "utils/filter-array-by";
import { InputField } from "components/input-field";
import { parseEnumBancoToNomeBanco } from "components/atendimentos-components/atendimento-form/contracts-table/consts";
import { moverElemento } from "utils/array-methods";

export function ChangeBancoVendeAI() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isLoadingBancos, setLoadingBancos] = useState(false);
  const [bancos, setBancos] = useState<{ banco: string }[]>([]);
  const [bancosNaoConfigurados, setBancosNaoConfigurados] = useState<string[]>(
    []
  );
  const [desconfigurarBancos, setDesconfigurarBancos] = useState<string[]>([]);
  const { user } = useApplicationContext();
  const apiVendeAI = new VendeAIAPI(user.userData.customerId!);

  const onOpen = () => {
    setIsOpen(true);
    apiVendeAI.getBanks({
      setLoading: setLoadingBancos,
      setBancos,
      onClose,
      setBancosNaoConfigurados,
    });
  };

  const onClose = () => {
    setIsOpen(false);
    setBancos([]);
    setBancosNaoConfigurados([]);
    setDesconfigurarBancos([]);
  };

  const onSubmit = async () => {
    apiVendeAI.changeBancos({
      bancos,
      setBancos,
      setLoading,
      onClose,
      setBancosNaoConfigurados,
      desconfigurarBancos,
    });
  };

  const modalFooter = (
    <>
      <Button
        leftIcon={<FaSave />}
        onClick={onSubmit}
        isLoading={isLoading}
        loadingText="Salvando"
      >
        Salvar
      </Button>{" "}
      <Button
        leftIcon={<CloseIcon w="12px" h="12px" />}
        variant={"outline"}
        onClick={onClose}
      >
        Cancelar
      </Button>
    </>
  );

  const mountTextBancos = (bancos: string[]) => {
    if (!bancos.length) return;
    return bancos.map((b) => parseEnumBancoToNomeBanco(b)).join(", ");
  };

  const deleteBanco = ({ banco }: { banco: string }) => {
    setDesconfigurarBancos([...desconfigurarBancos, banco]);
    setBancos((prev) => prev.filter(({ banco: b }) => b !== banco));
  };

  return (
    <Flex alignItems="center">
      <Text fontWeight="medium">Prioridade bancos VendeAI</Text>
      <Button leftIcon={<EditIcon />} onClick={onOpen} ml="8px" size="xs">
        Alterar
      </Button>
      <CustomModal
        isOpen={isOpen}
        modalTitle="Configurar Banco VendeAI"
        onClose={onClose}
        modalFooter={modalFooter}
      >
        <Text mb="8px" lineHeight="1.2" fontWeight="medium">
          Selecione a ordem de prioridade dos bancos da IA
        </Text>
        <Text color="gray.500" mb="10px" fontSize="12px" fontStyle="italic">
          Caso os bancos de maior prioridade estejam com instabilidade, a IA
          tentará usar os bancos de menor prioridade.
        </Text>
        {isLoadingBancos ? (
          <Center h="90px" w="100%">
            <Spinner />
          </Center>
        ) : (
          bancos.map(({ banco }, i, arr) => {
            const isLast = i + 1 === arr.length;
            return (
              <Box key={i} mb="10px">
                <Flex w="100%">
                  <Flex w="calc(100% - 52px - 8px)">
                    <InputField
                      value={parseEnumBancoToNomeBanco(banco)}
                      isReadyOnly
                    />
                  </Flex>
                  <Flex ml="8px" alignItems="center">
                    <IconButton
                      aria-label="up"
                      size="xs"
                      variant="outline"
                      mr="4px"
                      icon={<ChevronUpIcon />}
                      isDisabled={i === 0}
                      onClick={() => {
                        setBancos((prev) => [...moverElemento(prev, i, i - 1)]);
                      }}
                    />
                    <IconButton
                      aria-label="down"
                      size="xs"
                      variant="outline"
                      mr="4px"
                      icon={<ChevronDownIcon />}
                      isDisabled={isLast}
                      onClick={() => {
                        setBancos((prev) => [...moverElemento(prev, i, i + 1)]);
                      }}
                    />
                    <IconButton
                      aria-label="down"
                      size="xs"
                      variant="outline"
                      icon={<DeleteIcon />}
                      onClick={() => deleteBanco({ banco })}
                    />
                  </Flex>
                </Flex>
              </Box>
            );
          })
        )}
        {/* <Text color="gray.500" mb="10px" fontSize="12px" fontStyle="italic">
          Nessa tela só serão mostrados bancos com: tabela "Prioridade" da IA selecionada e usuário digitador cadastrado.
          Os seguintes bancos não estão sendo mostrados por esse motivo: {mountTextBancos(bancosNaoConfigurados)}
        </Text> */}
        {bancosNaoConfigurados.length > 0 ? (
          <>
            <Text color="gray.500" mb="10px" fontSize="12px" fontStyle="italic">
              Nessa tela só serão mostrados bancos com: tabela "Prioridade" da
              IA selecionada e usuário digitador cadastrado. Por esse motivo, os
              seguintes bancos não estão sendo mostrados:
            </Text>
            <Text color="gray.500" mb="10px" fontSize="12px" fontStyle="italic">
              {mountTextBancos(bancosNaoConfigurados)}
            </Text>
          </>
        ) : null}
      </CustomModal>
    </Flex>
  );
}
